<template>
  <div class="catalog-admin">
    <div class="catalog-toolbar">
      <el-input v-model.trim="query" clearable :placeholder="kind === 'makers' ? '搜索社团名称、DLsite ID 或内部 ID' : '搜索作品名称、DLsite ID 或内部 ID'" prefix-icon="el-icon-search" @keyup.enter.native="search" @clear="search"></el-input>
      <el-button type="primary" @click="search">搜索</el-button>
    </div>
    <div class="catalog-options">
      <p class="catalog-hint">{{ kind === 'makers' ? '编辑社团页展示的外部站点链接。' : '按内部 ID 编辑作品，同一 DLsite ID 的不同版本可分别修改。' }}</p>
      <div v-if="kind === 'makers'" class="maker-controls">
        <el-select v-model="makerFilter" size="small" aria-label="筛选社团" @change="search">
          <el-option label="全部社团" value="all"></el-option>
          <el-option label="无 Ci-en 地址" value="noCiEn"></el-option>
          <el-option label="有 Ci-en、无其他站点" value="ciEnOnly"></el-option>
        </el-select>
        <el-select v-model="sortBy" size="small" aria-label="排序字段" @change="search">
          <el-option label="社团 ID" value="id"></el-option>
          <el-option label="名称" value="name"></el-option>
          <el-option label="添加日期" value="created"></el-option>
          <el-option label="其他站点数量" value="otherSites"></el-option>
        </el-select>
        <el-button size="small" :icon="direction === 'asc' ? 'el-icon-top' : 'el-icon-bottom'" @click="toggleDirection">{{ direction === 'asc' ? '升序' : '降序' }}</el-button>
      </div>
    </div>
    <el-table v-loading="loading" :data="rows" row-key="id" stripe size="small" class="catalog-table">
      <el-table-column v-if="kind === 'works'" prop="id" label="内部 ID" min-width="90"></el-table-column>
      <el-table-column label="DLsite ID" min-width="120" v-if="kind === 'makers'">
        <template slot-scope="scope"><el-link type="primary" :href="makerDlsiteUrl(scope.row)" target="_blank" rel="noopener noreferrer">{{ scope.row.dlsiteId }}</el-link></template>
      </el-table-column>
      <el-table-column prop="gameId" label="DLsite ID" min-width="115" v-else></el-table-column>
      <el-table-column prop="name" :label="kind === 'makers' ? '社团' : '作品'" min-width="210" show-overflow-tooltip></el-table-column>
      <el-table-column v-if="kind === 'makers'" label="Ci-en 地址" min-width="240" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-link v-if="safeHttpUrl(scope.row.links && scope.row.links.ciEnUrl)" type="primary" :href="scope.row.links.ciEnUrl" target="_blank" rel="noopener noreferrer" class="site-url">{{ scope.row.links.ciEnUrl }}</el-link>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column v-if="kind === 'makers'" label="其他站点" min-width="105">
        <template slot-scope="scope">
          <el-tooltip v-if="otherLinks(scope.row).length" placement="top" effect="dark">
            <div slot="content" class="other-sites-tooltip">
              <div v-for="site in otherLinks(scope.row)" :key="site.key" class="other-site-record">
                <strong>{{ site.label }}</strong>
                <a v-if="safeHttpUrl(site.url)" :href="site.url" target="_blank" rel="noopener noreferrer">{{ site.url }}</a>
                <span v-else>{{ site.url }}</span>
              </div>
            </div>
            <span class="other-sites-count" tabindex="0">{{ otherLinks(scope.row).length }} 个</span>
          </el-tooltip>
          <span v-else>0 个</span>
        </template>
      </el-table-column>
      <el-table-column v-else prop="translatedName" label="译名" min-width="165" show-overflow-tooltip></el-table-column>
      <el-table-column v-if="kind === 'works'" prop="typeName" label="类型" min-width="110" show-overflow-tooltip></el-table-column>
      <el-table-column v-if="kind === 'works'" prop="languageName" label="语言" width="90"></el-table-column>
      <el-table-column v-if="kind === 'works'" prop="version" label="版本" width="100" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" :width="kind === 'works' ? 150 : 90" fixed="right"><template slot-scope="scope"><el-button type="text" @click="edit(scope.row)">编辑</el-button><el-button v-if="kind === 'works'" type="text" :loading="refreshingId === scope.row.id" :disabled="Boolean(refreshingId) && refreshingId !== scope.row.id" @click="refreshName(scope.row)">更新名字</el-button></template></el-table-column>
    </el-table>
    <el-pagination class="catalog-pages" background layout="total, prev, pager, next" :total="total" :page-size="20" :current-page.sync="page" @current-change="load"></el-pagination>

    <el-dialog :title="kind === 'makers' ? '编辑社团外部站点' : '编辑作品信息'" :visible.sync="dialogVisible" width="min(92vw, 590px)" append-to-body>
      <div class="edit-identity"><strong>{{ selected && selected.name }}</strong><span>内部 ID {{ selected && selected.id }}</span></div>
      <el-form ref="editForm" :model="form" :rules="rules" label-width="105px" size="small" @submit.native.prevent>
        <template v-if="kind === 'makers'">
          <el-form-item v-for="field in linkFields" :key="field.key" :label="field.label" :prop="field.key">
            <el-input v-model.trim="form[field.key]" :placeholder="field.label + ' 地址，留空可清除'"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="DLsite ID" prop="gameId"><el-input v-model.trim="form.gameId" maxlength="10"></el-input></el-form-item>
          <el-form-item label="作品名" prop="name"><el-input v-model="form.name" maxlength="255"></el-input></el-form-item>
          <el-form-item label="译名" prop="translatedName"><el-input v-model.trim="form.translatedName" maxlength="255"></el-input></el-form-item>
          <el-form-item label="类型" prop="type"><el-select v-model="form.type" placeholder="选择类型" filterable><el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select></el-form-item>
          <el-form-item label="语言" prop="language"><el-select v-model="form.language" placeholder="选择语言"><el-option v-for="item in languages" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select></el-form-item>
          <el-form-item label="版本" prop="version"><el-input v-model.trim="form.version" maxlength="20" placeholder="留空可清除"></el-input></el-form-item>
        </template>
      </el-form>
      <span slot="footer"><el-button @click="dialogVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
const linkFields = [
  { key: 'dlsiteUrl', label: 'DLsite' }, { key: 'ciEnUrl', label: 'Ci-en' },
  { key: 'dmmUrl', label: 'FANZA' }, { key: 'pixivUrl', label: 'Pixiv' },
  { key: 'twitterUrl', label: 'X / Twitter' }, { key: 'homepageUrl', label: '官网' },
  { key: 'blogUrl', label: '博客' }
]
const validLink = (rule, value, callback) => {
  if (!value) return callback()
  try {
    const url = new URL(value)
    if (['http:', 'https:'].includes(url.protocol) && value.length <= 1000) return callback()
  } catch (e) { /* invalid URL */ }
  callback(new Error('请输入有效的 HTTP 或 HTTPS 地址（最多 1000 字符）'))
}
export default {
  name: 'AdminCatalog',
  props: { kind: { type: String, required: true } },
  data() {
    const rules = { gameId: [{ required: true, message: '请输入 DLsite ID', trigger: 'blur' }],
      name: [{ validator: (rule, value, callback) => String(value || '').trim() ? callback() : callback(new Error('请输入作品名')), trigger: 'blur' }],
      type: [{ required: true, message: '请选择类型', trigger: 'change' }],
      language: [{ required: true, message: '请选择语言', trigger: 'change' }] }
    linkFields.forEach(field => { rules[field.key] = [{ validator: validLink, trigger: 'blur' }] })
    return { query: '', page: 1, total: 0, rows: [], loading: false, saving: false, refreshingId: '', dialogVisible: false,
      makerFilter: 'all', sortBy: 'name', direction: 'asc',
      selected: null, form: {}, types: [], languages: [], linkFields, rules }
  },
  created() { this.load(); this.loadOptions() },
  watch: { kind() { this.query = ''; this.page = 1; this.load(); this.loadOptions() } },
  methods: {
    headers() { return { Authorization: 'Bearer ' + localStorage.getItem('token') } },
    async load() {
      this.loading = true
      try {
        const params = { query: this.query, pageNo: this.page }
        if (this.kind === 'makers') Object.assign(params, {
          noCiEn: this.makerFilter === 'noCiEn',
          ciEnWithoutOtherSites: this.makerFilter === 'ciEnOnly',
          sortBy: this.sortBy,
          direction: this.direction
        })
        const response = await axios.get('/api/admin/catalog/' + this.kind, { headers: this.headers(), params })
        if (response.data.code !== 200) throw new Error(response.data.message)
        this.rows = response.data.data.rows || []
        this.total = response.data.data.total || 0
      } catch (error) { this.$message.error(error.response?.status === 403 ? '登录已过期，请重新登录' : (error.response?.data?.message || error.message || '加载失败')) }
      finally { this.loading = false }
    },
    search() { this.page = 1; this.load() },
    toggleDirection() { this.direction = this.direction === 'asc' ? 'desc' : 'asc'; this.search() },
    async loadOptions() {
      if (this.kind !== 'works') return
      try {
        const [types, languages] = await Promise.all([axios.get('/api/open/select/type'), axios.get('/api/open/select/language')])
        this.types = types.data.data || []; this.languages = languages.data.data || []
      } catch (error) { this.$message.error('类型和语言选项加载失败') }
    },
    otherLinks(row) {
      return linkFields.filter(field => field.key !== 'dlsiteUrl' && field.key !== 'ciEnUrl')
        .map(field => ({ ...field, url: String((row.links || {})[field.key] || '').trim() }))
        .filter(site => site.url)
    },
    safeHttpUrl(value) {
      if (!value) return ''
      try { return ['http:', 'https:'].includes(new URL(value).protocol) ? value : '' }
      catch (error) { return '' }
    },
    makerDlsiteUrl(row) {
      return this.safeHttpUrl(row.links && row.links.dlsiteUrl)
        || `https://www.dlsite.com/maniax/circle/profile/=/maker_id/${encodeURIComponent(row.dlsiteId)}.html`
    },
    edit(row) {
      this.selected = row
      if (this.kind === 'works' && (!this.types.length || !this.languages.length)) this.loadOptions()
      this.form = this.kind === 'makers' ? { ...row.links } : {
        gameId: row.gameId || '', name: row.name || '', translatedName: row.translatedName || '',
        type: row.type, language: row.language, version: row.version || ''
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate())
    },
    async refreshName(row) {
      if (this.refreshingId) return
      this.refreshingId = row.id
      try {
        const response = await axios.post(`/api/admin/catalog/works/${row.id}/refresh-name`, {}, { headers: this.headers() })
        if (response.data.code !== 200) throw new Error(response.data.message)
        this.$message.success(`作品名已更新为：${response.data.data.name}`)
        await this.load()
      } catch (error) { this.$message.error(error.response?.status === 403 ? '登录已过期，请重新登录' : (error.response?.data?.message || error.message || '更新作品名失败')) }
      finally { this.refreshingId = '' }
    },
    save() {
      this.$refs.editForm.validate(async valid => {
        if (!valid || !this.selected) return
        this.saving = true
        const path = this.kind === 'makers' ? `makers/${this.selected.id}/links` : `works/${this.selected.id}`
        try {
          const response = await axios.put('/api/admin/catalog/' + path, this.form, { headers: this.headers() })
          if (response.data.code !== 200) throw new Error(response.data.message)
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.load()
        } catch (error) { this.$message.error(error.response?.status === 403 ? '登录已过期，请重新登录' : (error.response?.data?.message || error.message || '保存失败')) }
        finally { this.saving = false }
      })
    }
  }
}
</script>

<style scoped>
.catalog-toolbar { display:flex; gap:8px; max-width:640px; }
.catalog-options { display:flex; align-items:center; justify-content:space-between; gap:12px; margin:10px 0 15px; flex-wrap:wrap; }
.catalog-hint { color:#909399; font-size:12px; margin:0; }
.maker-controls { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
.maker-controls .el-select { width:142px; }
.maker-controls .el-select:first-child { width:182px; }
.catalog-table { width:100%; background:transparent; }
.catalog-table >>> th, .catalog-table >>> tr, .catalog-table >>> td { background:rgba(255,255,255,.25); }
.catalog-pages { margin-top:16px; text-align:right; }
.edit-identity { display:flex; flex-direction:column; gap:4px; margin-bottom:20px; }
.edit-identity span { color:#909399; font-size:12px; }
.el-select { width:100%; }
.site-url { display:inline-block; max-width:100%; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; vertical-align:middle; }
.other-sites-count { cursor:help; text-decoration:underline dotted; text-underline-offset:3px; }
.other-sites-tooltip { max-width:min(360px, 80vw); }
.other-site-record { display:flex; gap:8px; line-height:1.6; overflow-wrap:anywhere; }
.other-site-record + .other-site-record { margin-top:5px; }
.other-site-record strong { flex:none; }
.other-site-record a { color:#b3d8ff; }
@media (max-width:767px) { .catalog-table { overflow-x:auto; } .catalog-pages { white-space:nowrap; overflow-x:auto; } }
</style>
